import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage";
import { ts } from 'src/utils/translate'
import { Button } from "@mui/material";

export const CustomSectionButton = (
    {
        customSectionButtonPressed,
        setCustomSectionButtonPressed,
        setCurrentRowInEditing,
    } : {
        customSectionButtonPressed: any;
        setCustomSectionButtonPressed: any;
        setCurrentRowInEditing: any;
    }
) => {

    return !IS_READ_ONLY_USER ? (
        <div id="sections-adder" className="remove-on-export">
            <Button
                className="lightershadow add-row-btn btn blue-uplan"
                sx={{
                    padding: "5px",
                    paddingX: "15px",
                    color: "white",
                    borderRadius: "6px",
                    textTransform: "none",
                    fontSize: "14px",
                    cursor: "pointer"
                }}
                onClick={() => {
                    if (!customSectionButtonPressed) {
                        setCustomSectionButtonPressed(true);
                    }
                    setCurrentRowInEditing({ tableId: "new section" });
                }}
            >
                { ts("q_add_custom_section", "Add Custom Section") }
            </Button>
        </div>
    ) : (
        <div id="sections-adder">
            <Button
                className=" add-row-btn btn blue-uplan disable"
                sx={{
                    padding: "5px",
                    paddingX: "15px",
                    color: "white",
                    borderRadius: "6px",
                    textTransform: "none",
                    fontSize: "14px",
                    cursor: "pointer"
                }}
            >
                {ts("q_add_custom_section", "Add Custom Section")}
            </Button>

        </div>
    );
};
